import Grid from '@blocks/Grid'
import useGallery from '@customer/models/Gallery/useGallery'
import useSalon from '@customer/models/Salon/useSalon'
import { getHeadingBySalon } from '@helpers'
import useTitle from '@hooks/useTitle'
import MainContainer from '@blocks/MainContainer'
import useMainTemplate from '@templates/Main/hooks/useMainTemplate'
import React from 'react'
import { useParams } from 'react-router-dom'
import SalonHeader from './components/Header'
import SalonSections from './components/Sections'
import SalonContext from './context'
import SalonInfo from './components/Info'
import SalonTimeline from './components/Timeline/SalonTimeline'

export default function SalonPage() {
    const { id } = useParams<{ id: string }>()

    const salon = useSalon(id)
    const gallery = useGallery()

    useTitle(`Salon: ${salon.attrs.name()}`)
    useMainTemplate({ category: salon.state?.status })
    salon.use.participateIfCurrent()
    
    if (!salon.state) 
        return null

    return (
        <SalonContext.Provider value={{ salon, gallery } as Customer.Contexts.Salon}>
            <MainContainer heading={getHeadingBySalon(salon.state)}>
                <Grid gap="15px">
                    <SalonHeader />
                    {salon.state.status !== "unavailable" && (
                        <Grid>
                            <SalonTimeline />
                            <SalonInfo />
                            <SalonSections />
                        </Grid>
                    )}
                </Grid>
            </MainContainer>
        </SalonContext.Provider>
        
    )
}